import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/core/react/router';

import { useSapToDm } from './hooks/useSapToDm';

export const SapToDm: React.FC = () => {
	const {
		data: { displayName, id },
		actions: { trackSapClick },
	} = useSapToDm();

	return (
		<div className="border-stroke-disabled space-y-6 rounded-xl border p-4 text-left md:p-10">
			<Text as="h2" variant="heading">
				<Translate value="corgi.decision_maker_profile.sap_to_dm.heading" replacements={{ displayName }} />
			</Text>
			<div className="flex justify-center md:justify-start">
				<Button
					to={`/start-a-petition?source_location=dm_profile_page&decision_maker_id=${id}`}
					as={Link}
					variant="primary"
					className="whitespace-normal md:w-fit"
					data-qa="dm-sap-cta-button"
					onClick={trackSapClick}
				>
					<Translate value="corgi.decision_maker_profile.sap_to_dm.button" replacements={{ displayName }} />
				</Button>
			</div>
		</div>
	);
};
